module.exports = __webpack_public_path__ + "assets/img/GENERAL_AUTOSTART_PLUGIN.9429bc7a.svg";